import {Component, Inject, OnInit} from '@angular/core';
import {User} from '../../../data/models/user';
import {UserService} from '../../../services/api/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-user-delete-dialog',
  templateUrl: './user-delete-dialog.component.html',
  styleUrls: ['./user-delete-dialog.component.css']
})
export class UserDeleteDialogComponent implements OnInit {

  user: User;

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<UserDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      user: User,
    },
  ) {
    this.user = data.user;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.userService.deleteUser(this.user.id)
      .then(() => this.dialogRef.close(true));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
